export default __webpack_public_path__ + "static/media/ethereum-icon-light.600bc502.svg";